import React from "react";
import Accordion from "../../components/Workflow_Components/Accordion";
import Playground from "../../components/Workflow_Components/Playground";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { v4 as uuid } from "uuid";
import "../styles.css";
import { useDispatch, useSelector } from 'react-redux';




const Automationstudio = (props) => {

  const workflow = useSelector((state) => state.workflowSetter);
  console.log("worflowDataworflowData",workflow);

  const urlToAllWorkflows = () => {
    props.history.push("/admin/workflow/all_workflows");
  };
  return (
   <>
   <div className="workflow-header">
    <div className="det">
      
  
    <h3>{workflow.workflowName}</h3>
    <p>{workflow.workflowDescription}</p>
    </div>
    <button
        onClick={urlToAllWorkflows}
        className="sm_btn primary kw_wf_button"
        style={{ width: "120px" ,backgroundColor: "#2C40CE", fontWeight:500 }}
      >
        Save & Exit
      </button>

   </div>
    <DndProvider backend={HTML5Backend}>
      <div
        className="automation_studio"
        style={{ display: "flex", flexDirection: "row-reverse" }}
      >
        <div style={{ marginTop: 30, marginRight: 30 }}>
          <Accordion key={uuid()} urlToAllWorkflows={urlToAllWorkflows} />
        </div>
        <div
          className="playground"
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            marginTop: 30,
            width: "max-content",
            overflow: "scroll",
            height: "100vh",
            scrollbarWidth: "none",
          }}
        >
          <Playground key={uuid()} />
        </div>
        {/* </TransformWrapper> */}
      </div>
    </DndProvider>
    </>
  );
};

export default Automationstudio;
